export default __webpack_public_path__ + "static/media/Border-Edit-Icon.972f6af8.svg";